import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { IResult } from '../../httpClient/serverApi/types/IResponse';

export type FavoriteRepresentation = IResult & {
  contentId: string;
  contentType: string;
  position?: Number;
};

export interface FavoritesResponseRawData {
  contentId: string;
  type: string;
  sortPosition?: number;
}

// TODO: we will need to replace this with the Monolith/Kube relative path once configured
// Integration Tests: /content-favorites/favorites
// Local Development: http://localhost:9090/favorites
const FAVORITES_URL = '/content-favorites/favorites';


function getFavorites(userId: string): Promise<Array<FavoriteRepresentation>> {
  const requestConfig: AxiosRequestConfig = {
    method: 'GET',
    url: FAVORITES_URL,
    params: {
      userId
    },
  };

  return axios.request<Array<FavoritesResponseRawData>>(requestConfig).then(response => mapAll(response.data));
}

function add(favorite: FavoriteRepresentation, userId: string): Promise<FavoriteRepresentation> {

  const requestConfig: AxiosRequestConfig = {
    method: 'POST',
    data: {
      userId,
      type: favorite.contentType,
      contentId: favorite.contentId
    },
    url: FAVORITES_URL,
  };

  return axios.request<FavoritesResponseRawData>(requestConfig).then(mapOne);
}

function remove(favorite: FavoriteRepresentation, userId: string): Promise<IResult> {
  const requestConfig: AxiosRequestConfig = {
    method: 'DELETE',
    url: `${FAVORITES_URL}/${favorite.contentType}/${favorite.contentId}`,
    params: {
      userId
    },
  };

  return axios.request<FavoritesResponseRawData>(requestConfig).then(mapOne);
}

function mapAll(favoriteData: FavoritesResponseRawData[]): Array<FavoriteRepresentation> {
  return favoriteData?.map(map) ?? [];
}

function mapOne(response: AxiosResponse<FavoritesResponseRawData>): FavoriteRepresentation {
  const favoriteResponse = response.data;
  return map(favoriteResponse);
}

function map(favoriteResponse: FavoritesResponseRawData): FavoriteRepresentation {
  return {
    contentId: favoriteResponse.contentId,
    contentType: favoriteResponse.type,
    position: favoriteResponse.sortPosition,
  };
}

export const FavoritesResource = {
  getFavorites,
  add,
  remove
};
